import { render, staticRenderFns } from "./EventForm.vue?vue&type=template&id=7c7ba90c&scoped=true"
import script from "./EventForm.vue?vue&type=script&lang=js"
export * from "./EventForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7ba90c",
  null
  
)

export default component.exports